import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { reactPlugin } from './components/appInsights/appInsights';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';




// ReactDOM.render(
  
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );


ReactDOM.render(
  <AppInsightsContext.Provider value={reactPlugin}>
    <App />
  </AppInsightsContext.Provider>,
  document.getElementById("root")
);